import { CLEAR_LIKES, UPDATE_LIKES, UPDATING_LIKED, SET_LIKED } from "../reducers/actiontypes";

const initialState = (function(state={}) {
	state.loaded = state.loaded || (state.liked !== undefined) || false;
	state.liked = state.liked || false;
	state.likes = state.likes || 0;
	return state;
})(window.commentstate.likes);

export default function(state=initialState, action) {
	switch (action.type) {
		case CLEAR_LIKES:
			return { ...state, likes: 0, liked: false };
		case UPDATE_LIKES:
			return { ...state, likes: action.likes, liked: action.liked, loaded:true };
		case UPDATING_LIKED:
			return { ...state, loaded: false };
		case SET_LIKED:
			return { ...state, liked: action.liked, likes: state.likes + (action.liked ? 1 : -1), loaded: true };
		default:
			return state;
	}
}
